import React from "react";
import RevenueLineChart from "./charts/RevenueLineChart";
import LTVLineChart from "./charts/LTVLineChart";
import Slider from "react-slick";
import styles from "./index.module.scss";
import cn from "classnames";

const RevenueResult = () => {
  const settings = {
    className: "center",
    infinite: true,
    slidesToShow: 1,
    speed: 500,
    rows: 2,
    slidesPerRow: 1,
    dotsClass: `slick-dots ${styles.slickDots}`,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          infinite: true,
          dots: true,
          rows: 1,
        },
      },
    ],
  };

  return (
    <div className={styles.wrapper}>
      <h2 className={cn("subheader-medium", styles.title)}>Result</h2>

      <div className={styles.charts}>
        <Slider {...settings}>
          <RevenueLineChart />
          <LTVLineChart />
        </Slider>
      </div>
    </div>
  );
};

export default RevenueResult;
